import { render, staticRenderFns } from "./new-drager.vue?vue&type=template&id=22cef3ca&scoped=true"
import script from "./new-drager.vue?vue&type=script&lang=js"
export * from "./new-drager.vue?vue&type=script&lang=js"
import style0 from "./new-drager.vue?vue&type=style&index=0&id=22cef3ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cef3ca",
  null
  
)

export default component.exports